import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import EditOffersModal from "./edit-offers-modal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'create-offers-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The unique identifier for the contact.
   * @type {number}
   * @default 0
   */
  contactId: {
    type: Number,
    default: 0,
  },
  /**
   * The unique identifier for the property.
   * @type {number}
   * @default 0
   */
  propertyId: {
    type: Number,
    default: 0,
  },
  /**
   * Indicates whether offer modal includes time.
   * @type {boolean}
   * @default true
   */
  includeTime: {
    type: Boolean,
    default: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  "modalClosed",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(EditOffersModal, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event)),
    offerId: 0,
    includeTime: props.includeTime,
    contactId: props.contactId,
    onModalClosed: _cache[1] || (_cache[1] = (updated) => emit('modalClosed', updated)),
    propertyId: props.propertyId,
    newOffer: true
  }, null, 8, ["modelValue", "includeTime", "contactId", "propertyId"]))
}
}

})